import { render } from "./TranslationsModelsList.vue?vue&type=template&id=453ca48e&scoped=true"
import script from "./TranslationsModelsList.vue?vue&type=script&lang=js"
export * from "./TranslationsModelsList.vue?vue&type=script&lang=js"

import "./TranslationsModelsList.vue?vue&type=style&index=0&id=453ca48e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453ca48e"]])

export default __exports__